var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['col-familles']},[_c('span',{staticClass:"tri-bloc"},[_c('span',[_vm._v(_vm._s(_vm.$t('companies_familles')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }